/* eslint-disable max-len */
import { Heading } from '../../typography/heading/Heading';
import { Text } from '../../typography/text/Text';
import Title from '../../typography/title';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { theme } from './_vars';
import { StylesCustomizer } from '../../molecules/stylesCustomizer';

export const TeaserContent = ({
  isMain = false,
  label = '',
  labelStyles,
  title = '',
  titleStyles,
  subtitle = '',
  subTitleStyles,
  accentText = false,
  button = null,
  isOverlay,
  overlayTheme,
  mobileButton = null,
  verticalPosition = 'center', // top, center, bottom
  horizontalPosition = 'center', // left center right
  textAlign = 'center', // left center right
  breakpoint = null,
  layoutType,
  styles = {
    content: '',
    textBox: '',
    buttonGroup: '',
    accentedText: '',
    teaserHeader: '',
  },
}) => {
  if (!label && !title && !subtitle && !button && !mobileButton) return null;

  const textTheme = isOverlay && overlayTheme ? overlayTheme : 'dark';

  const contentClasses = clsx(
    styles.content,
    styles.contentPaddings,
    styles.horizontalPosition,
    styles[`horizontalPosition__${horizontalPosition}`],
    styles[`verticalPosition__${verticalPosition}`],
    styles[`contentLayout_${layoutType}`],
  );

  const LabelText = (variables) => {
    return (
      <Text
        as="span"
        weight="semibold"
        align={horizontalPosition}
        className={styles.teaserLabel}
        variables={variables}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        />
      </Text>
    );
  };
  const TitleText = (variables) => {
    return (
      <Heading
        align={horizontalPosition}
        className={styles.teaserHeader}
        as="h2"
        styleAs="h1"
        placement="plp"
        textTransform={theme === 'Jag' ? 'lowercase' : 'uppercase'}
        weight={theme === 'Jag' ? 'semibold' : 'light'}
        variables={variables}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </Heading>
    );
  };
  const SubTitleText = (variables) => {
    return (
      <Text
        as="p"
        size="xs"
        weight="bold"
        className={styles.teaserSubtitle}
        align={horizontalPosition}
        variables={variables}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
      </Text>
    );
  };

  const AccentTitleText = (variables) => {
    return (
      <Heading
        align={horizontalPosition}
        className={styles.teaserHeader}
        as="h2"
        styleAs="h1"
        placement="plp"
        textTransform="uppercase"
        weight="light"
        variables={variables}
      >
        <span
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </Heading>
    );
  };
  const AccentSubTitleText = (variables) => {
    return (
      <p className={styles.accentedText} style={{ ...variables }}>
        <span
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
      </p>
    );
  };

  const StyledLabelText = StylesCustomizer(LabelText);
  const StyledTitleText = StylesCustomizer(TitleText);
  const StyledSubTitleText = StylesCustomizer(SubTitleText);
  const StyledAccentTitleText = StylesCustomizer(AccentTitleText);
  const StyledAccentSubTitleText = StylesCustomizer(AccentSubTitleText);

  return (
    <div className={contentClasses}>
      <div
        className={clsx(
          styles.textBox,
          styles[textAlign],
          styles[`text_${textTheme}`],
        )}
      >
        {!accentText ? (
          <>
            {(label || title || subtitle) ? (
              <Title customClasses={{ title: styles.title }}>
                {label && <StyledLabelText styles={labelStyles} />}
                {title && <StyledTitleText styles={titleStyles} />}
                {subtitle && <StyledSubTitleText styles={subTitleStyles} />}
              </Title>
            ) : null}
            <div
              className={clsx(
                styles.buttonGroup,
                styles[`horizontalPosition__${horizontalPosition}`],
                styles[`verticalPosition__${verticalPosition}`],
                styles[`contentLayout_${layoutType}`],
                {[styles.onlyButtons]: !label && !title && !subtitle}
              )}
            >
              {isMain && breakpoint.small && mobileButton ? (
                <>
                  {button}
                  {mobileButton}
                </>
              ) : (
                button && button
              )}
            </div>
          </>
        ) : (
          <>
            {title ? <StyledAccentTitleText styles={titleStyles} /> : null}
            {subtitle ? <StyledAccentSubTitleText styles={subTitleStyles} /> : null}
            <div className={clsx(styles.buttonGroup, {[styles.onlyButtons]: !label && !title && !subtitle})}>
              {isMain && breakpoint.small && mobileButton ? (
                <>
                  {button}
                  {mobileButton}
                </>
              ) : (
                button && button
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

TeaserContent.propTypes = {
  isMain: PropTypes.bool,
  verticalPosition: PropTypes.oneOf(['top', 'center', 'bottom']),
  horizontalPosition: PropTypes.oneOf(['left', 'center', 'right']),
  textAlign: PropTypes.oneOf(['left', 'center', 'right']),
  label: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  accentText: PropTypes.bool,
  breakpoint: PropTypes.shape({}),
  mobileButton: PropTypes.node,
  button: PropTypes.node,
  styles: PropTypes.shape({
    content: PropTypes.string,
    textBox: PropTypes.string,
    buttonGroup: PropTypes.string,
    accentedText: PropTypes.string,
    teaserHeader: PropTypes.string,
  }),
};
